var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.75,
    cy: 10,
    r: 10,
    fill: "#CF0A2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.244 5.00586L15.744 6.50586L14.6005 7.64986L13.1005 6.14986L14.244 5.00586ZM8.75 11.9999H10.25L13.8935 8.35636L12.3935 6.85636L8.75 10.4999V11.9999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 13.5H8.829C8.816 13.5 8.8025 13.505 8.7895 13.505C8.773 13.505 8.7565 13.5005 8.7395 13.5H7.25V6.5H10.6735L11.6735 5.5H7.25C6.6985 5.5 6.25 5.948 6.25 6.5V13.5C6.25 14.052 6.6985 14.5 7.25 14.5H14.25C14.5152 14.5 14.7696 14.3946 14.9571 14.2071C15.1446 14.0196 15.25 13.7652 15.25 13.5V9.166L14.25 10.166V13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifyIcon);
export default __webpack_public_path__ + "static/media/modifyIcon.ed06c1bc973c77aa7d123eb51a285950.svg";
export { ForwardRef as ReactComponent };